import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PartnerUserByMeService } from "./partner-user-be-me.service";
import { SetNewPasswordService } from "./set-new-password.service";

@NgModule({
  imports: [CommonModule],
  providers: [PartnerUserByMeService, SetNewPasswordService],
})
export class PartnerUsersModule {}
